import { gql } from "@apollo/client";

export const STORES = gql`
  query stores($limit: Int) {
    stores {
      id
      name
      sid
      brand {
        id
        logo {
          id
          thumbnail
          url
        }
      }
      integrations {
        integration_id
        integration_type
      }
      address {
        location {
          latitude
          longitude
        }
        door_number
        building_name
        line1
        line2
        city_town
        country
        postcode
        county
      }
      products {
        id
        product_code
        name
        prices {
          price
          gross_price
          last_updated
          taxes {
            id
            name
            rate
          }
          history(limit: $limit) {
            points {
              gross_price
              price
              time
            }
            trend
          }
          price_type_id
        }
      }
    }
  }
`;

export const STORES_WITH_PRICES = gql`
  query stores($limit: Int) {
    stores {
      id
      name
      sid
      brand {
        id
        logo {
          id
          thumbnail
          url
        }
      }
      integrations {
        integration_id
        integration_type
      }
      address {
        location {
          latitude
          longitude
        }
        door_number
        building_name
        line1
        line2
        city_town
        country
        postcode
        county
      }
      products {
        id
        product_code
        name
        prices {
          price
          last_updated
          gross_price
          taxes {
            id
            name
            rate
          }
          history(limit: $limit) {
            points {
              gross_price
              price
              time
            }
            trend
          }
          price_type_id
        }
      }
    }
  }
`;

export const STOCK_TYPES = gql`
  query stock_types {
    stock_types {
      id
      name
    }
  }
`;

export const PURCHASE_STOCKS = gql`
  query purchase_stocks(
    $from: NaiveDateTime
    $to: NaiveDateTime
    $stock_types: [UUID!]
    $product_ids: [UUID!]
  ) {
    purchase_stocks(
      from: $from
      to: $to
      stock_types: $stock_types
      product_ids: $product_ids
    ) {
      update_time
      products {
        product {
          id
          name
          product_code
        }
        stocks {
          id
          available_stock
          purchase_price
          purchase_stock
          stock_type {
            id
            name
          }
        }
      }
    }
  }
`;

export const UPDATE_PURCHASE_PRICE = gql`
  mutation ($prices: [UpdateProductPurchasePriceInput!]!) {
    update_purchase_prices(prices: $prices)
  }
`;
